import { StandaloneAuth } from '@leagueplatform/auth-standalone';

export function logout() {
  StandaloneAuth.client.logout({
    returnTo: window.location.origin,
  });
}
